import React from 'react';
import { PageTitle, UnderConstruction } from "../styledComponents";


function Resources() {
  return (
    <UnderConstruction>
    <PageTitle>PAGE UNDER CONSTRUCTION</PageTitle>
    </UnderConstruction>
  );
}

export default Resources;
